import { render, staticRenderFns } from "./ReturnCustomers.vue?vue&type=template&id=44c19281&scoped=true&"
import script from "./ReturnCustomers.vue?vue&type=script&lang=js&"
export * from "./ReturnCustomers.vue?vue&type=script&lang=js&"
import style0 from "./ReturnCustomers.vue?vue&type=style&index=0&id=44c19281&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c19281",
  null
  
)

export default component.exports